import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Footer} from '../../components';
import {
  redirectToValidationAccessCode,
  redirectToFinish,
  redirectToYourCard,
} from '../../ducks/Navigate';
import {verAssinaturaContrato} from '../../ducks/Customer';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class Signature extends Component {
  state = {
    hideBtnNext: true,
    hideBtnBack: false,
    urlIframe: '',
    pdfBase64: '',
  };

  async componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.Signature.title);

    if (this.props.urlAcessoDigital) {
      let urlIframe = this.props.urlAcessoDigital;
      this.setState({urlIframe});
    }
    window.addEventListener(
      'message',
      (event) => this.receiveMessage(event),
      false,
    );
  }

  receiveMessage = (event) => {
    if (event.data && event.data.toLowerCase() === 'ok') {
      let hideBtnNext = false;
      this.setState({hideBtnNext});

      let hideBtnBack = true;
      this.setState({hideBtnBack});
    }
  };

  componentWillUnmount() {
    window.removeEventListener('message', (event) =>
      this.receiveMessage(event),
    );
  }

  openContract = async () => {
    let base64 = await this.props.verAssinaturaContrato({
      chave: this.props.chave,
    });

    if (base64) {
      let a = document.createElement('a');
      a.href = `data:application/octet-stream;base64,${base64}`;
      a.download = 'Contrato.pdf';
      a.click();
    }
  };

  render() {
    return (
      <>
        <div className="div-signature">
          <div className="content">
            <div className="info ">
              <p className="title"> E para finalizar, </p>
            </div>

            <div className="info">
              <p className="info-content">
                Precisamos da sua <strong>assinatura.</strong>
                <br />
                Não se preocupe se não ficar idêntica ao seu documento.
              </p>
            </div>
            <div className="div-frame">
              {this.state.urlIframe && (
                <iframe title="Assinatura" src={this.state.urlIframe}></iframe>
              )}
            </div>
            <div className="info">
              <p className="info-content">
                Ao enviar sua proposta, você está concordando com nosso
                contrato. Para ver a Proposta:
                <br />
                <button className="link" onClick={this.openContract}>
                  clique aqui
                </button>
              </p>
            </div>
          </div>
          <div className="footer-signature">
            <Footer
              hideBtnNext={this.state.hideBtnNext}
              textNext="Enviar Proposta"
              nextHandle={() => {
                this.props.redirectToFinish();
              }}
              hideBtnBack={this.state.hideBtnBack}
              backHandle={() => {
                this.props.redirectToYourCard();
              }}
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({customer}) => {
  const {chave, urlAcessoDigital} = customer;
  return {chave, urlAcessoDigital};
};

export default connect(mapStateToProps, {
  redirectToYourCard,
  verAssinaturaContrato,
  redirectToValidationAccessCode,
  redirectToFinish,
})(Signature);
